import { useBlocker } from 'react-router-dom';
import { useEffect } from 'react';
import { resetCart } from '../slices/cartSlice';
import { useDispatch } from 'react-redux';

// This ref should be declared outside the hook to persist between calls
let allowedPathRef = null;

function useExitGuard(shouldBlock) {
    const dispatch = useDispatch();

    const blocker = useBlocker(shouldBlock);

    useEffect(() => {
        if (blocker.state === 'blocked') {
            const targetPath = blocker.location.pathname + blocker.location.search;

            // ✅ Allow programmatic navigation with page refresh and no warning
            if (allowedPathRef) {
                allowedPathRef = null;
                dispatch(resetCart());
                window.location.href = targetPath;
                return;
            }

            const confirmed = window.confirm(
                '¿Seguro que deseas salir? Esto reiniciará el método de pago, y te enviará a la página principal.'
            );
            if (confirmed) {
                window.location.href = targetPath;
            } else {
                blocker.reset();
            }
        }
    }, [blocker, dispatch]);
}

export function allowNextNavigation(path) {
    allowedPathRef = path;
}

export default useExitGuard;
